import { render, staticRenderFns } from "./StudentAchievementList.vue?vue&type=template&id=601b4e8d&scoped=true"
import script from "./StudentAchievementList.vue?vue&type=script&lang=js"
export * from "./StudentAchievementList.vue?vue&type=script&lang=js"
import style0 from "./StudentAchievementList.vue?vue&type=style&index=0&id=601b4e8d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b4e8d",
  null
  
)

export default component.exports